import type { ActionMenuItems } from '@moneyforward/ap-frontend-components';
import { LinkButton } from '@moneyforward/ap-frontend-components';
import classnames from 'classnames/bind';
import styles from './InvoiceReportsButtonGroup.module.scss';

const cx = classnames.bind(styles);

export type CreateMyApplicationProxyItemsParams = {
  t: (key: string) => string;
  onMyApplication?: () => void;
  onProxyApplication?: () => void;
};

/**
 * Returns ActionMenuItems for "自身の申請" + "代理申請" (click-only, no link).
 * Used by ProxyOnButtonGroup for Export and Import dropdowns.
 */
export function createMyApplicationProxyMenuItems({
  t,
  onMyApplication,
  onProxyApplication,
}: CreateMyApplicationProxyItemsParams): ActionMenuItems {
  return [
    {
      key: 'my_application',
      label: (
        <span className={cx('btnLinkText')}>
          {t('invoice_reports.button_groups.register_my_application')}
        </span>
      ),
      onClick: onMyApplication,
    },
    {
      key: 'proxy_application',
      label: (
        <span className={cx('btnLinkText')}>
          {t('invoice_reports.button_groups.proxy_application')}
        </span>
      ),
      onClick: onProxyApplication,
    },
  ];
}

export type CreateLinkAndProxyMenuItemsParams = {
  t: (key: string) => string;
  href: string | undefined;
  disabled: boolean;
  onProxyClick: () => void;
  myApplicationKey?: string;
  proxyKey?: string;
  proxyItemClassName?: string;
};

/**
 * Returns ActionMenuItems for "自身の申請" (LinkButton) + "代理申請" (onClick).
 * Used by ProxyOnButtonGroup for AI OCR and Create new dropdowns.
 */
export function createLinkAndProxyMenuItems({
  t,
  href,
  disabled,
  onProxyClick,
  myApplicationKey = 'my_application',
  proxyKey = 'proxy_application',
  proxyItemClassName = cx('btnLinkContainerCustom'),
}: CreateLinkAndProxyMenuItemsParams): ActionMenuItems {
  return [
    {
      key: myApplicationKey,
      label: (
        <LinkButton
          isTransparent
          href={href}
          buttonContainerClassName={cx('btnLinkContainerCustom')}
          buttonClassName={cx(
            disabled ? 'btnLinkCustom_disabled' : 'btnLinkCustom'
          )}
        >
          {t('invoice_reports.button_groups.register_my_application')}
        </LinkButton>
      ),
      disabled,
    },
    {
      key: proxyKey,
      className: proxyItemClassName,
      label: (
        <span className={cx('btnLinkText')}>
          {t('invoice_reports.button_groups.proxy_application')}
        </span>
      ),
      onClick: onProxyClick,
    },
  ];
}
